import { Platform } from 'react-native';
import { getIOSActiveSubscriptionProductIds } from 'goalmint-subscription-store';
import { SUBSCRIPTION_PRODUCT_IDS } from '../config/revenuecat';
import { SubscriptionTier } from '../types/subscription';

const PREMIUM_FIRST_PRODUCT_ORDER = [
  'premium_yearly',
  'premium_monthly',
  'standard_yearly',
  'standard_monthly',
] as const;

export function tierFromProductIds(productIds: string[]): SubscriptionTier {
  if (productIds.some((id) => id.includes('premium'))) return 'premium';
  if (productIds.some((id) => id.includes('standard'))) return 'standard';
  return 'free';
}

export function pickPrimaryProductId(productIds: string[]): string | undefined {
  for (const preferred of PREMIUM_FIRST_PRODUCT_ORDER) {
    const match = productIds.find(
      (id) => id === preferred || id.endsWith(`.${preferred}`) || id.includes(preferred)
    );
    if (match) return match;
  }
  return productIds.find((id) =>
    SUBSCRIPTION_PRODUCT_IDS.some(
      (known) => id === known || id.endsWith(`.${known}`) || id.includes(known)
    )
  );
}

export function mergeProductIds(...lists: string[][]): string[] {
  return [...new Set(lists.flat().filter(Boolean))];
}

export async function getStoreKitActiveProductIds(): Promise<string[]> {
  if (Platform.OS !== 'ios') return [];
  try {
    return (await getIOSActiveSubscriptionProductIds()) ?? [];
  } catch (error) {
    console.warn('StoreKit active subscriptions unavailable:', error);
    return [];
  }
}
